import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { ENV, environment } from '@hyper-inferno/hyper-base-ng';
import {
  BOT_SERVICE_TOKEN,
  COMPONENT_REGISTRY,
} from '@hyper-inferno/survey-elements-core-ui';
import { PreviewBot } from './preview-bot';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    provideRouter(
      [],
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }),
    ),
    {
      provide: ENV,
      useValue: environment,
    },
    { provide: BOT_SERVICE_TOKEN, useClass: PreviewBot },
    {
      provide: COMPONENT_REGISTRY,
      useValue: {
        'open-ended': () =>
          import('@hyper-inferno/open-ended-ui').then((m) => m.OpenEndedUi),
        'single-choice': () =>
          import('@hyper-inferno/single-choice-ui').then(
            (m) => m.SingleChoiceUi,
          ),
        'multiple-choice': () =>
          import('@hyper-inferno/multiple-choice-ui').then(
            (m) => m.MultipleChoiceUi,
          ),
        numeric: () =>
          import('@hyper-inferno/numeric-ui').then((m) => m.NumericUi),
        video: () => import('@hyper-inferno/video-ui').then((m) => m.VideoUi),
        voice: () => import('@hyper-inferno/voice-ui').then((m) => m.VoiceUi),
        'click-to-rank': () =>
          import('@hyper-inferno/click-to-rank-ui').then(
            (m) => m.ClickToRankUi,
          ),
        'drop-down-single-choice': () =>
          import('@hyper-inferno/drop-down-single-choice-ui').then(
            (m) => m.DropDownSingleChoiceUi,
          ),
        'drop-down-multiple-choice': () =>
          import('@hyper-inferno/drop-down-multiple-choice-ui').then(
            (m) => m.DropDownMultipleChoiceUi,
          ),
        image: () => import('@hyper-inferno/image-ui').then((m) => m.ImageUi),
      },
    },
  ],
};
